// src/components/ui/Marque.tsx — SCE Issues
// Logo Sartorius et signet « S », tirés des fichiers officiels (29/09).
//
// Maquette validée le 29/09 : https://claude.ai/artifact/MxrE1KnEhx9HscxWG1MQTe
// Logo : en-tête de l'accueil au bureau, connexion, pied de l'écran
// d'ouverture et du menu du compte. Signet : en-tête de l'accueil au
// téléphone (la place manque). Rien sur les pages de travail.
//
// Les SVG de src/assets/marque/ sont les fichiers de la marque recadrés au
// ras du dessin : la marge autour du logo (au moins sa hauteur, comme dans
// les fichiers d'origine) est tenue par la mise en page, pas par le fichier.
// Remplacer le logo = remplacer le fichier, en gardant ce recadrage.
//
// En <img> : toujours noir (les SVG utilisent currentColor, qui vaut noir
// hors du document). C'est ce qu'il faut sur le blanc, le gris et le jaune de
// l'appli. Vite les inclut dans le code (moins de 4 Ko) : aucune requête.

import logo from '@/assets/marque/sartorius-logo.svg'
import signet from '@/assets/marque/sartorius-signet.svg'

/** Largeur / hauteur des dessins recadrés (viewBox des fichiers). */
export const RATIO_LOGO = 1637.79 / 295.06
export const RATIO_SIGNET = 184.85 / 283.47

/** Logo complet « SARTORIUS ». La hauteur est celle des lettres, en px. */
export function LogoSartorius({ hauteur }: { hauteur: number }): JSX.Element {
  return (
    <img
      src={logo}
      alt="Sartorius"
      width={Math.round(hauteur * RATIO_LOGO)}
      height={hauteur}
      style={{ display: 'block', flexShrink: 0 }}
    />
  )
}

/** Signet « S » seul, quand la place manque. */
export function SignetSartorius({ hauteur }: { hauteur: number }): JSX.Element {
  return (
    <img
      src={signet}
      alt="Sartorius"
      width={Math.round(hauteur * RATIO_SIGNET)}
      height={hauteur}
      style={{ display: 'block', flexShrink: 0 }}
    />
  )
}
